import type {
    DistanceBucket,
    DriverSpeedBucket,
    EngineRpmBucket,
    ThrottleBucket,
} from '../cloud/api';

export function speedToBucket(maxSpeedKmh: number): DriverSpeedBucket {
    if (!Number.isFinite(maxSpeedKmh) || maxSpeedKmh <= 0) return 'unknown';
    if (maxSpeedKmh < 60) return 'under_60';
    if (maxSpeedKmh < 90) return '60_90';
    if (maxSpeedKmh < 120) return '90_120';
    return '120_plus';
}

export function distanceToBucket(distanceKm: number): DistanceBucket {
    if (!Number.isFinite(distanceKm) || distanceKm < 5) return 'under_5km';
    if (distanceKm < 15) return '5_15km';
    if (distanceKm < 30) return '15_30km';
    return '30km_plus';
}

export function rpmToBucket(avgRpm: number): EngineRpmBucket | undefined {
    if (!Number.isFinite(avgRpm) || avgRpm <= 0) return undefined;
    if (avgRpm < 1500) return 'low';
    if (avgRpm < 3000) return 'medium';
    return 'high';
}

export function throttleToBucket(avgThrottlePct: number): ThrottleBucket | undefined {
    if (!Number.isFinite(avgThrottlePct) || avgThrottlePct <= 0) return undefined;
    if (avgThrottlePct < 25) return 'gentle';
    if (avgThrottlePct < 60) return 'moderate';
    return 'heavy';
}
